import type { MouseEvent } from 'react';

export function scrollToSection(event: MouseEvent<HTMLAnchorElement>): boolean {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    (event.currentTarget.target && event.currentTarget.target !== '_self')
  ) {
    return false;
  }

  const destination = new URL(event.currentTarget.href);
  if (
    destination.origin !== window.location.origin ||
    destination.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '') ||
    !destination.hash
  ) {
    return false;
  }

  const section = document.getElementById(destination.hash.slice(1));
  if (!section) return false;

  event.preventDefault();
  window.scrollTo({
    top: section.getBoundingClientRect().top + window.scrollY - 80,
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
  });
  return true;
}
